import React, { useState } from 'react'
import { Box, Switch } from '@mui/material'
import { useStyles } from '../../styles/ToggleComponent.styles'

export type GridViewType = 'PL' | 'PN'

interface GridViewToggleProps {
  value?: GridViewType
  onChange?: (view: GridViewType) => void
}

export const GridViewToggle: React.FC<GridViewToggleProps> = ({
  value: controlledValue,
  onChange,
}) => {
  const { classes } = useStyles()
  const [internalValue, setInternalValue] = useState<GridViewType>('PL')

  const currentValue = controlledValue ?? internalValue
  const isPN = currentValue === 'PN'

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue: GridViewType = event.target.checked ? 'PN' : 'PL'
    if (controlledValue === undefined) {
      setInternalValue(newValue)
    }
    onChange?.(newValue)
  }

  return (
    <Box className={classes.toggleContainer}>
      <span className={classes.label}>PL</span>
      <Switch
        checked={isPN}
        onChange={handleChange}
        className={classes.switch}
        slotProps={{ input: { 'aria-label': 'toggle between PL and PN view' } }}
      />
      <span className={classes.label}>PN</span>
    </Box>
  )
}
